export default {
  id: null,
  gedPastaID: null,
  nome: null,
  inicio: null,
  validade: null,
  diasAlerta: null,
  emailsAlerta: null,
  gedAssuntoID: null,
  gedTipoID: null,
  formato: null,
  observacao: null,
  favorito: null,
  tamanho: null,
  versao: null,
  seguranca: false,
  gedArquivoTags: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/business/gedfilemodel.js